import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import { Image } from "@mantine/core";

import SDALogo from "@/assets/sda-logo.svg";

import { ThemedButton } from "./ThemedButton";

function SDATransitionAnnouncementModal() {
	const [isFirstTime, setIsFirstTime] = useState(true);

	useEffect(() => {
		// Check if user has seen the announcement before
		const hasSeen = localStorage.getItem("hasSeenSDAAnnouncementBefore");

		if (hasSeen === "true") {
			setIsFirstTime(false);
		} else {
			setIsFirstTime(true);
		}
	}, []);

	return (
		<>
			<Modal
				className="modal-dialog-centered"
				size="lg"
				contentClassName="custom-modal-content"
				isOpen={isFirstTime}>
				<div className="modal-header pb-0">
					<div className="modal-header-wrap">
						<span style={{ fontSize: "20px", fontWeight: "bold", color: "#003640" }}>
							Announcement
						</span>
					</div>
				</div>
				<div className="modal-body">
					<Image src={SDALogo} alt="FCA Logo" w={200} h={"auto"} fit="contain" />
					<span
						style={{
							fontSize: "16px",
							fontWeight: "400",
							fontStyle: "italic",
							color: "#616161",
						}}>
						Formerly FirstCom Academy
					</span>
					<hr className="my-3" style={{ borderColor: "#000" }} />
					<p
						style={{
							fontSize: "16px",
							fontWeight: "bold",
							color: "#003640",
						}}>
						Dear Learner,
					</p>
					<p
						style={{
							fontSize: "16px",
							color: "#000000",
						}}>
						FirstCom Academy has rebranded as <b>Skills Development Academy</b>.
					</p>
					<p
						style={{
							fontSize: "16px",
							color: "#000000",
						}}>
						This rebranding reflects our growth and strengthened vision as{" "}
						<b>we continue to provide relevant, accessible, and high-quality training</b> for
						everyone.
					</p>
					<p
						style={{
							fontSize: "16px",
							color: "#000000",
						}}>
						Thank you for your continued trust and support.
					</p>
					<div className="text-right mt-5">
						<ThemedButton
							px={100}
							type="button"
							onClick={() => {
								setIsFirstTime(false);
								localStorage.setItem("hasSeenSDAAnnouncementBefore", "true");
							}}>
							Continue
						</ThemedButton>
					</div>
				</div>
			</Modal>
		</>
	);
}

export default SDATransitionAnnouncementModal;
